import { createContext, useState, useEffect } from "react";

export const ReportsContext = createContext({
  report: [],
  setReport: () => {},
  generateReport: () => {},
  clearReport: () => {},
});

export const ReportsProvider = ({ children }) => {
  const [report, setReport] = useState([]);

  const generateReport = (reportFunction = () => {}, filename = "") => {
    if (!Array.isArray(report)) throw new Error("Report must be an array");
    reportFunction(report, filename);
  };

  const clearReport = () => {
    setReport([]);
  };

  return (
    <ReportsContext.Provider
      value={{
        report,
        setReport,
        generateReport,
        clearReport,
      }}
    >
      {children}
    </ReportsContext.Provider>
  );
};
